// src/data/notifications.js

// Utilidades de fecha
function getSectionFromDate(date) {
  const now = new Date();
  const d = new Date(date);

  if (isNaN(d.getTime())) return "Anterior";

  const diffMs = now.getTime() - d.getTime();

  if (diffMs < 0) {
    return "Hoy";
  }

  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Hoy";
  if (diffDays === 1) return "Ayer";
  if (diffDays <= 7) return "La semana pasada";
  return "Anterior";
}

function getTimeLabel(date) {
  const now = new Date();
  const d = new Date(date);

  if (isNaN(d.getTime())) return "";

  let diffMs = now.getTime() - d.getTime();

  if (diffMs < 0) diffMs = 0;

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMinutes < 1) return "hace un momento";
  if (diffMinutes < 60) return `hace ${diffMinutes} min`;
  if (diffHours < 24) return `hace ${diffHours} horas`;
  if (diffDays === 1) return "Ayer";
  if (diffDays <= 7) return `hace ${diffDays} días`;
  return "La semana pasada";
}

// 🔹 Datos base de notificaciones
export const notificationsData = [
  {
    id: 1,
    title: "Título de la notificación",
    description: "Aqui irán apareciendo las notificaciones a medida que avance el proyecto.",
    date: "2025-12-01T11:20:00",
    highlight: true,
    cta: "Únase a la acción",
    isUnread: true,
  }
];

// 🔹 Notificaciones enriquecidas (section + timeLabel)
export const enhancedNotifications = notificationsData.map((n) => ({
  ...n,
  section: getSectionFromDate(n.date),
  timeLabel: getTimeLabel(n.date),
}));

// 🔹 Secciones que usas en la página
export const notificationSections = [
  "Hoy",
  "Ayer",
  "La semana pasada",
  "Anterior",
];
